import logoFc from "../../assets/PNG/logo20262.png";
import useWindowSize from "../../hooks/sizeWindow";
// import pulgar from "../../assets/iconos/microfono.png";
// import logoMobile from "../../assets/PNG/fdlc_vRecurso.png";
import logoFc2 from "../../assets/PNG/logo20262.png";
import microfono from "../../assets/iconos/microfono.png";
import { Link, useNavigate } from "react-router-dom";

const NoDisponible = () => {
    const size = useWindowSize();
    const nav = useNavigate();

    // console.log(size.width)

    return (
        <main className="pb-5 ">
            <section className="  d-flex flex-column align-items-center pb-3 text-white mx-auto   pt-5 " style={{ width: "100%", maxWidth: size.width < "500" ? "400px" : size.width < "700" ? "600px" : size.width < "1000" ? "700px" : "" }}>

                {
                    size.width > "500"
                        ?
                        <img src={logoFc} alt="Logo-Fiesta-Confluencia" className="" style={{ width: "100%", maxWidth: size.width < "500" ? "400px" : size.width < "700" ? "500px" : "600px" }} />
                        :
                        <img src={logoFc2} alt="Logo-Fiesta-Confluencia" className="" style={{ width: "100%", maxWidth: size.width < "500" && "400px" }} />
                }

                <section className="d-flex flex-column align-items-center gap-4  " style={{ maxWidth: size.width < "500" ? "400px" : "500px" }}>


                    <div className="d-flex flex-column gap-3 align-items-center mt-5">

                        <p className={`${size.width > "500" ? "parrafoLG" : "parrafoSM"} noSelect text-center  py-2 px-5  text-WHITE bg-danger py-2 px-4 `} style={{ transform: "rotate(-3deg)" }} >503</p>
                        <p className={`${size.width > "500" ? "parrafoSM" : "parrafoXSM"} noSelect text-center  py-2 px-4 `} >Servicio no disponible</p>
                    </div>



                    <div className="d-flex flex-column gap-2 align-items-center">
                        <p className={`${size.width > "500" ? "parrafSM" : "parrafoXSM"} noSelect  py-2 px-4 text-center`} style={{ color: "#FFF" }}>
                            Lo sentimos, pero el servidor no puede manejar la solicitud en este momento.
                        </p>
                        <p className={`${size.width > "500" ? "parrafSM" : "parrafoXSM"} noSelect  py-2 px-4 text-center`} style={{ color: "#FFF" }}>
                            Por favor, inténtalo de nuevo más tarde.
                        </p>
                        {/* <a href="https://fiestaconfluencia.com/entradas" target="_black" style={{ backgroundColor: "#A349FF", color: "#FFF" }} className={`${size.width > "500" ? "parrafoXSM" : "parrafoXXSM"} py-1 px-2 rounded`} >EntradaUno</a> */}
                    </div>

                    {/* <div className="d-flex  align-items-center gap-5 ">
    <p className={`${size.width > "500" ? "parrafoLG" : "parrafoSM"}  noSelect  w-100 px-4`}>
      Están excluidas de participar todas las personas que pertenezcan a la planta
      política del Municipio de la ciudad de Neuquén
    </p>
  </div> */}
                    <img style={{ maxWidth: size.width < 500 ? "80px" : "100px" }} src={microfono} alt="" />

                    {/* <img style={{ width: size.width > "500" ? "250px" : "130px", zIndex: 1 }} className="mt-4" src={pulgar} alt="sol-icon" /> */}
                    {/* <button onClick={() => nav('/')} className="mt-5 px-3" style={{ backgroundColor: "#FFA000", border: "none" }}>INICIO</button> */}
                    <button onClick={() => nav('/')} className="mt-5 px-3" style={{ backgroundColor: "#52278A", border: "none", color: "#fff" }}>INICIO</button>

                </section>
            </section>
        </main>
    );
};
export default NoDisponible;
